import React from "react";
import { Link } from "react-router-dom";
import { BlurFade } from "../BlurFade";

export interface ISocials {
  url: string;
  name: string;
  link: string;
}

type PropType = {
  images?: string[];
  socialLinks: ISocials[];
};

const Social: React.FC<PropType> = ({ images, socialLinks }) => {
  // todo: add links here

  return (
    <BlurFade delay={0.25} inView>
      <div className="p-5 sm:p-7 lg:p-20 xl:px-[11rem] flex justify-center items-center">
        <div className="grid md:grid-cols-5 gap-5">
          <div className="grid col-span-2 gap-5">
            <div className="flex flex-col text-2xl md:-ml-2 xl:-ml-4 font-normal sm:text-3xl md:text-4xl xl:text-6xl xl:leading-tight">
              <h3>Follow us on</h3>
              <h3>social to see</h3>
              <h3>what we're up to!</h3>
            </div>
            <div className="h-full flex w-full md:justify-end">
              <img
                src={images?.[0] || "/socials/socials-1.png"}
                alt=""
                className="h-full w-full"
              />
            </div>
          </div>
          <div className="col-span-1 grid justify-center gap-5">
            <div className="w-full">
              <img
                src={images?.[1] || "/socials/socials-2.png"}
                alt=""
                className="w-full h-full md:h-96"
              />
            </div>
            <div className="flex justify-end">
              <img
                src={images?.[2] || "/socials/socials-3.png"}
                alt=""
                className="w-full"
              />
            </div>
          </div>
          <div>
            <img
              src={images?.[3] || "/socials/socials-4.png"}
              alt=""
              className="w-full h-full"
            />
          </div>
          <div className="grid grid-cols-2 gap-5 col-span-2 md:grid-cols-1 md:col-span-1 ml-2">
            <div>
              <img
                src={images?.[4] || "/socials/socials-5.png"}
                alt=""
                className="w-full h-full md:h-fit"
              />
            </div>
            <div className="flex flex-1 flex-col justify-end pb-4 xl:pb-6">
              <div className="font-normal text-sm sm:text-2xl md:text-base lg:text-lg xl:text-2xl">
                <h3>
                  We are eager to be in touch with you in the following
                  channels:
                </h3>
              </div>
              <div className="flex gap-5 pt-3 md:pb-16 lg:pb-20">
                {/* todo: add socials link here */}
                <div className="flex flex-col gap-5 w-fit">
                  {socialLinks.slice(0, 3).map((social) => {
                    return (
                      <Link
                        to={social.link}
                        target="_blank"
                        key={social.name}
                        className="flex gap-2 items-center w-fit"
                      >
                        <img src={social.url} alt="" className="w-7" />
                        <div className="hidden lg:flex">{social.name}</div>
                      </Link>
                    );
                  })}
                </div>
                {/* <div className="flex flex-col gap-5">
                  {socialLinks.slice(3).map((social) => {
                    return (
                      <Link
                        to={social.link}
                        key={social.name}
                        className="flex gap-2 items-center"
                      >
                        <img src={social.url} alt="" className="w-7" />
                        <div className="hidden xl:flex">{social.name}</div>
                      </Link>
                    );
                  })}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlurFade>
  );
};

export default Social;
